export default __webpack_public_path__ + "static/media/aquarium.d3a96cf5.jpg";